module.exports = __webpack_public_path__ + "img/green-checkmark.5ffc540b.gif";